var N = Object.defineProperty, w = Object.defineProperties;
var z = Object.getOwnPropertyDescriptors;
var l = Object.getOwnPropertySymbols;
var v = Object.prototype.hasOwnProperty, y = Object.prototype.propertyIsEnumerable;
var p = (e, r, t) => r in e ? N(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, c = (e, r) => {
  for (var t in r || (r = {}))
    v.call(r, t) && p(e, t, r[t]);
  if (l)
    for (var t of l(r))
      y.call(r, t) && p(e, t, r[t]);
  return e;
}, b = (e, r) => w(e, z(r));
var C = (e, r) => {
  var t = {};
  for (var n in e)
    v.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && l)
    for (var n of l(e))
      r.indexOf(n) < 0 && y.call(e, n) && (t[n] = e[n]);
  return t;
};
import { jsx as a, jsxs as $, Fragment as j } from "react/jsx-runtime";
import { useMemo as B } from "react";
const M = {
  inherit: "bg-inherit text-inherit border-inherit",
  primary: "bg-lime-500 border-lime-500 text-lime-950 hover:bg-lime-300 hover:border-lime-300",
  secondary: "bg-orange-600 border-orange-600 text-orange-950 hover:bg-orange-400 hover:border-orange-400",
  default: "bg-cyan-500 border-cyan-500 text-teal-950 hover:bg-cyan-300 hover:border-cyan-300",
  special: "bg-fuchsia-900 border-fuchsia-900 text-fuchsia-50 hover:bg-fuchsia-700 hover:border-fuchsia-700",
  danger: "bg-rose-600 border-rose-600 text-white hover:bg-rose-500 hover:border-rose-500"
}, I = {
  inherit: "inherit",
  primary: "text-lime-700 hover:text-lime-800",
  secondary: "text-amber-900 hover:text-orange-900",
  default: "text-teal-800 hover:text-cyan-700",
  special: "text-purple-950 hover:text-fuchsia-900",
  danger: "text-rose-700 hover:text-rose-600"
}, T = (e, r) => e === "outlined" ? "bg-white border-neutral-400 text-zinc-800 hover:bg-zinc-300 hover:border-zinc-300 disabled:text-neutral-500 disabled:bg-transparent disabled:border-gray-200" : e == "text" ? "border-transparent " + I[r || "default"] + " disabled:text-neutral-500" : M[r || "default"] + " disabled:text-neutral-500 disabled:bg-gray-200 disabled:border-gray-200", k = (e) => e === "large" ? "px-6 py-4 text-lg leading-none min-h-[3.5rem] space-x-2" : e === "small" ? "px-4 py-2 text-sm leading-none min-h-[2rem] space-x-2" : "px-5 py-3 leading-none min-h-[2.75rem] space-x-2";
function F(e, r, t, n, o) {
  const s = n ? "rounded-full" : "rounded-lg", i = o ? "flex w-full" : "inline-flex";
  return `border ${T(e, r)} ${k(
    t
  )} ${s} cursor-pointer disabled:cursor-not-allowed font-semibold ${i} items-center justify-center text-center`;
}
const q = (e) => {
  const f = e, {
    disabled: r,
    startIcon: t,
    endIcon: n,
    variant: o,
    color: s,
    size: i,
    fullRounded: h,
    fullWidth: u,
    children: x
  } = f, d = C(f, [
    "disabled",
    "startIcon",
    "endIcon",
    "variant",
    "color",
    "size",
    "fullRounded",
    "fullWidth",
    "children"
  ]), m = B(
    () => F(o, s, i, h, u),
    [o, s, i, h, u]
  ) + (e.className ? " " + e.className : ""), g = /* @__PURE__ */ $(j, { children: [
    t ? /* @__PURE__ */ a("span", { children: t }) : null,
    t || n ? /* @__PURE__ */ a("span", { children: x }) : x,
    n ? /* @__PURE__ */ a("span", { children: n }) : null
  ] });
  return "href" in d && !r ? /* @__PURE__ */ a("a", b(c({}, d), { className: m, children: g })) : /* @__PURE__ */ a(
    "button",
    b(c({}, d), {
      disabled: r,
      className: m,
      children: g
    })
  );
};
export {
  q as B
};
